<template>
  <div>
    <domain-single :domainid="domainid" />
  </div>
</template>

<script>
import DomainSingle from '@/components/Domains/DomainSingle'

export default {
  name: 'DomainSingleView',
  components: {
    DomainSingle
  },
  props: {
    domainid: {
      type: [String, Number],
      required: true,
    }
  },
}
</script>
